import { filterOptions } from '@/utils/query-base'

const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])

export const pageSearch = {
  'abnoramlBillCode': {
    title: '异常单号',
    type: 'input',
    equation: all
  },
  'customerName': {
    title: '订单客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '订单客户'
    }
  },
  'fhd': {
    title: '发运单号',
    type: 'input',
    equation: all
  },
  'status': {
    title: '单据状态',
    type: 'select',
    dictionary: 'YCDJtauts',
    equation: all
  },
  'startDate': {
    title: '申请起始日期',
    type: 'date',
    equation: all,
    valueFormat: 'yyyy-MM-dd'
  },
  'endDate': {
    title: '申请结束日期',
    type: 'date',
    equation: all,
    valueFormat: 'yyyy-MM-dd'
  }
}

export default {
  'abnoramlBillCode': {
    title: '异常物流单号',
    slot: true,
    width: 110
  },
  'customerName': {
    title: '订单客户',
    width: 160
  },
  'sourceTextView': {
    title: '异常来源',
    width: 80
  },
  'requireProcessDate': {
    title: '要求处理时间',
    width: 140
  },
  'responsecontent': {
    title: '客户反馈信息',
    width: 180
  },
  'feedback': {
    title: '安吉反馈信息',
    width: 180
  },
  'feedbackDate': {
    title: '反馈时间',
    width: 140
  },
  'punishAmount': {
    title: '处罚金额',
    width: 80
  },
  'statusTextView': {
    title: '状态',
    width: 100
  },
  'createdDate': {
    title: '创建时间',
    width: 140
  },
  'createdByName': {
    title: '创建人',
    width: 100
  },
  'comment': {
    title: '备注'
  },
}



// WEBPACK FOOTER //
// ./src/views/apply-for-manage/data-searching/config/logisticsAbnormal.js